export const SidebarComponentHeading = ({
  children,
}: React.PropsWithChildren) => {
  return <h3 className="h3 mb-2 font-semibold">{children}</h3>;
};

export default SidebarComponentHeading;
